module.exports = __webpack_public_path__ + "img/nullMind.949c3bdb.svg";